export enum AcceleratorBatch {
  C1 = 'C1',
  C2 = 'C2',
}
